import { createContext, ReactNode, useContext } from 'react';
import { currencyCodesObj, ECardType } from '../utils';
import { IConfig } from '../types';

interface IAdditionalData {
  clientId: string;
  session: string;
  payPage: string;
  libInitializeId: string;
}

export interface IDataContext extends IAdditionalData {
  amount: number;
  currencyCode?: string;
  sessionGuid?: string;
  predefinedCardType: ECardType | null;
  paymentMethod: Partial<IConfig['paymentMethod']>;
  clientFeesDisclaimers: IConfig['clientFeesDisclaimers'];
  feesDisclaimers: IConfig['feesDisclaimers'];
  style: IConfig['style'];
  encryption: IConfig['encryption'] | null;
  softDescriptors: Partial<IConfig['softDescriptors']>;
  description: NonNullable<Partial<IConfig['description']>>;
}

const DataContext = createContext<IDataContext>({} as IDataContext);

export const useDataContext = () => useContext(DataContext);

export const DataProvider = ({
  children,
  data,
  ...otherData
}: {
  children: ReactNode;
  data: Partial<IConfig>;
} & IAdditionalData) => {
  const preparedData: IDataContext = {
    amount: +(data?.amount ?? 0),
    currencyCode: data?.currencyCode ?? currencyCodesObj.USD,
    sessionGuid: data?.sessionGuid,
    paymentMethod:
      data?.paymentMethod || ([] as Partial<IConfig['paymentMethod']>),
    predefinedCardType: (data?.preffiledCardType || null) as ECardType | null,
    clientFeesDisclaimers: data?.clientFeesDisclaimers ?? [],
    feesDisclaimers: data?.feesDisclaimers ?? [],
    style: data?.style,
    encryption: data?.encryption || {} as IConfig['encryption'],
    softDescriptors: data.softDescriptors || null,
    description: data.description || '',
    ...otherData,
  };

  return (
    <DataContext.Provider value={{ ...preparedData }}>
      {children}
    </DataContext.Provider>
  );
};
